module.exports = __webpack_public_path__ + "static/book-83f8d78c14c25cbe20bbf400af1cd73e.jpg";